// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"P12HalfTextHalfImage_imageContainer__ast9V","image":"P12HalfTextHalfImage_image__74Zpn"};